import * as variables from './variables.js';
import passiveIfSupported from "./lib/passiveIfSupported";

import './lib/AnimationEasing';

import {Analytics} from '@plaudit/analytics';
Analytics.getInstance({
    mirrorEvents: {
        microsoft: true     // Mirror events reported to GA to Microsoft's analytics (used for MS Ads)
	}
});

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import {MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});


// Sticky code
// const stickyActiveStyleClass = "stickyElement--isActive";
// const stickyElem = document.getElementsByClassName("stickyElement");
// const updateStickElements = () => {
// 	for (let i = 0; i < stickyElem.length; i++) {
// 		const elem = stickyElem[i] as HTMLElement;

// 		const stickyMode = elem.getAttribute("data-stickyElement-mode");


// 		const container = elem.parentElement;
// 		const containerBCR = container.getBoundingClientRect();
// 		const elemBCR = elem.getBoundingClientRect();

// 		if (stickyMode === "follow") {
// 			let positionToParent = elem.getAttribute("data-stickyElement-positionToParent");
// 			if (positionToParent === null) {
// 				positionToParent =
// 					(elemBCR.top - containerBCR.top <=  containerBCR.bottom - elemBCR.bottom)
// 						? "top"
// 						: "bottom";
// 				elem.setAttribute("data-stickyElement-positionToParent", positionToParent);
// 			}

// 			if (
// 				(positionToParent === "bottom" && containerBCR.bottom - elemBCR.height <= 0)
// 				|| (positionToParent === "top" && containerBCR.top <= 0)
// 			) {
// 				elem.classList.add(stickyActiveStyleClass);
// 			} else {
// 				elem.classList.remove(stickyActiveStyleClass);
// 			}
// 		} else if (stickyMode === "stickyToParent") {
// 			const elemFitsOnScreen = elemBCR.height < (window.innerHeight || window.document.documentElement.clientHeight);

// 			if(containerBCR.top <= 0 && elemFitsOnScreen) {
// 				elem.classList.add(stickyActiveStyleClass);
// 			} else {
// 				elem.classList.remove(stickyActiveStyleClass);
// 			}
// 		}
// 	}
// }
// window.addEventListener("scroll", updateStickElements, passiveIfSupported);
// window.addEventListener("resize", updateStickElements, passiveIfSupported);
// updateStickElements();



// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

import SearchForm from './component/HeaderSearchForm';
new SearchForm('.searchArea', '.searchArea__icon', '.searchArea__query', 'open');

import Forms from './component/Forms';
Forms.init();

import Gallery from './component/Gallery';
new Gallery();

/* Silky smooth scrolling */
import SmoothScroll from './component/SmoothScroll';
const mySmoothScroll = new SmoothScroll();
mySmoothScroll.add('.__jobLanding a[href*="#"]:not([onclick])', {
	duration: 1000,
	easing: 'easeOutCirc',
	offset: 50
});

import initAnimations from './component/Animations';
initAnimations();

import initGreeting from './component/2020Greeting';
initGreeting();

import StickyBits from './component/StickyBits';
StickyBits.init({
	elementsQuery: '.section--hasAside .section__asideInner.stickyElement',
	elementOffset: 0
});
